export enum ConversationItemTypeEnum {
    Email = 'email',
    InApp = 'in_app',
    System = 'system',
}